import { Button, Box } from '@mui/material'

// Hidden entirely when the page was opened without list context (§8) —
// there's no order to guess, so showing disabled buttons would be misleading.
const ResultNav = ({ hasContext, hasPrev, hasNext, onPrev, onNext }) => {
  if (!hasContext) return null

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button
        variant="outlined"
        size="small"
        disabled={!hasPrev}
        onClick={onPrev}
        aria-label="Previous result"
        sx={{ minWidth: 44, minHeight: 44 }}
      >
        <span className="fa-solid fa-chevron-left"></span>&nbsp;Prev
      </Button>
      <Button
        variant="outlined"
        size="small"
        disabled={!hasNext}
        onClick={onNext}
        aria-label="Next result"
        sx={{ minWidth: 44, minHeight: 44 }}
      >
        Next&nbsp;<span className="fa-solid fa-chevron-right"></span>
      </Button>
    </Box>
  )
}

export default ResultNav
